export enum FoodPopularity {
    CITY = 'CITY',
    REGION = 'REGION',
    COUNTRY = 'COUNTRY'
}